// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const VerticalAlignTopOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_4403)"},"children":[{"tag":"path","attrs":{"d":"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_4403"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"vertical_align_top","theme":"outlined"};

const VerticalAlignTopOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={VerticalAlignTopOutlinedSvg} />;
  VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(VerticalAlignTopOutlined);
